export default __webpack_public_path__ + "static/blue-container-bff1c1f810f0c8215dbc4617f946e910.svg";